module.exports = __webpack_public_path__ + "img/banner-medis-mobile.c2c3608c.png";